import { render } from "./ButtonBack.vue?vue&type=template&id=1f261e20&scoped=true"
import script from "./ButtonBack.vue?vue&type=script&lang=js"
export * from "./ButtonBack.vue?vue&type=script&lang=js"

import "./ButtonBack.vue?vue&type=style&index=0&id=1f261e20&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f261e20"]])

export default __exports__